<template>
  <v-dialog v-model="config.status.active" max-width="600px">
    <v-btn flat slot="activator" color="blue darken-2"><font-awesome-icon :icon="['fal', 'search']"></font-awesome-icon>&nbsp;検索登録</v-btn>
    <v-card>
      <v-card-title class="grey lighten-3 blue-grey--text text--darken-4"><span class="headline">保護者の新規登録</span></v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid">
            <v-layout wrap>
              <v-flex xs10>
                <v-text-field label="ふりがな or 名前"
                  v-model="form.primary"
                  @keypress.enter="search"></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn fab small color="blue darken-2 white--text"
                  :disabled="!isSearchable"
                  :loading="isSearching"
                  @click="search"><font-awesome-icon :icon="['fal', 'search']"></font-awesome-icon></v-btn>
              </v-flex>
              <v-flex xs12>
                <v-select v-show="getGuardianItems.length" required
                  v-model="form.gid"
                  item-text="name"
                  item-value="id"
                  :items="getGuardianItems"
                  :rules="rules.gid"
                  label="検索結果から保護者を選ぶ"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-combobox v-show="getGuardianItems.length" required
                  v-model="form.relation"
                  :items="meta.relations"
                  :rules="rules.relation"
                  label="続柄"></v-combobox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="grey lighten-3">
        <v-btn flat @click="close" color="blue darken-2">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="blue darken-2 white--text" :disabled="!isValid" :loading="isLoading" @click="submit">登録する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'clientAboutGuardiansModalSearch',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      meta: {
        relations: [
          '父',
          '母',
          '祖父',
          '祖母',
          '夫',
          '妻',
          'おじ',
          'おば',
          '息子',
          '娘',
          '孫',
          '兄',
          '姉',
          '弟',
          '妹'
        ]
      },
      form: {
        valid: true,
        primary: '',
        gid: '',
        relation: ''
      },
      rules: {
        gid: [
          v => !!v || '必須項目です'
        ],
        relation: [
          v => !!v || '必須項目です'
        ]
      },
      store: {
        guardians: []
      }
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    init: function () {
      this.prepare()
    },
    prepare: function () {
      this.$set(this, 'form', {
        valid: true,
        primary: '',
        gid: '',
        relation: ''
      })
    },
    update: function (values) {
      console.log(values)
    },
    search: function () {
      if (this.form.primary.trim() !== '') {
        this.$set(this.config.status, 'searching', true)
        this.axios.post(this.$url.api + 'user/about/search/guardians', {
          primary: this.form.primary.trim()
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'searching', false)
          if (res.data && res.data.success) {
            this.$set(this.store, 'guardians', res.data.data)
            this.$set(this.form, 'cid', '')
          }
        })
      }
    },
    select: function (id) {
      this.$set(this.form.id, 'value', id)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        let fd = {
          cid: this.$route.params.id,
          gid: this.form.gid,
          relation: this.form.relation
        }
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/about/link/guardian', fd, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data && res.data.success) {
            this.$emit('emit', {
              action: 'insert',
              data: res.data.data
            })
            this.close()
          }
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isSubmittable () {
      return Object.keys(this.form).filter(key => {
        return (this.form[key].required && this.form[key].value === '')
      }).length === 0
    },
    isSearchable () {
      return this.form.primary.trim() !== ''
    },
    getRelationItems () {
      return this.meta.relations
    },
    isGuardianEmpty () {
      return this.store.guardians.length === 0
    },
    getGuardianItems () {
      return (this.store.guardians && this.store.guardians.length) ? this.store.guardians.map(it => {
        return {
          id: it.id ? it.id : '',
          name: it.name ? it.name.join(' ') : ''
        }
      }) : []
    }
  }
}
</script>
